import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {useWorkspaceTabStore} from '@toolify/client/src/stores/WorkspaceTabStore/useWorkspaceTabStore'

export function syncWorkspaceTabsRouterHook(pinia: Pinia) {
  return function syncWorkspaceTabsRouterHookImpl(to: RouteLocationNormalized) {
    if(typeof to.params.workspaceName !== 'string') {
      return
    }
    useWorkspaceTabStore(pinia).syncFromRoute(to)
  }
}
